module.exports = __webpack_public_path__ + "img/artboard10.f60542c1.png";